import {AnimationItem} from 'lottie-web/build/player/lottie_light';
import ControllButton from './ControllButton';
import ICON_RUN_V4_LIGHT from '../../../../public/static/v4/viewer/icon-run-v4-light.json';
import ICON_RUN_V4 from '../../../../public/static/v4/viewer/icon-run-v4.json';
import Lottie from '../../../common/component/Lottie';
import useTheme from '../../../common/hook/useTheme';

interface IProps {
  lottieRef?: React.MutableRefObject<AnimationItem | undefined>;
  onClick: () => void;
  isRunMode?: boolean;
}

export default function RunModeButton({lottieRef, onClick, isRunMode}: IProps) {
  const {isLightMode} = useTheme();
  return (
    <ControllButton className="relative !border-0" onClick={onClick}>
      <>
        <div
          className="absolute inset-0 w-full h-full rounded-50per animate-spin"
          style={{
            animationDuration: '3s',
            background:
              'linear-gradient(45deg, #04CAFC 0%, #13BBFC 25%, #4C7EFC 50%, #7F48FC 75%, #9432FC 100%)',
          }}
        />
        {!isRunMode && (
          <div className="absolute inset-3 w-42 h-42 bg-black rounded-50per light:bg-white" />
        )}
        <Lottie
          className="relative w-48 h-48 p-12"
          animationData={
            isRunMode
              ? ICON_RUN_V4
              : isLightMode
                ? ICON_RUN_V4_LIGHT
                : ICON_RUN_V4
          }
          lottieRef={lottieRef}
          autoplay={isRunMode}
          loop={true}
        />
      </>
    </ControllButton>
  );
}
